<p>sidebar-item works!</p>
{{item | json}}
